import { z } from "zod";
export const ANALYTICS_WINDOWS = [7, 30, 90];
const dateFilter = z
    .string()
    .refine((value) => value === "" || /^\d{4}-\d{2}-\d{2}$/.test(value), "Date must use YYYY-MM-DD");
export const auditFilterSchema = z.object({
    actorId: z.string().max(80).default(""),
    action: z.string().max(120).default(""),
    entityType: z.string().max(80).default(""),
    from: dateFilter.default(""),
    to: dateFilter.default(""),
    page: z.number().int().min(1).default(1),
    pageSize: z.number().int().min(10).max(100).default(20)
});
